import axios from "axios";
import { getToken } from "./Tokens";

const apiClient = () => {
  // Debug: Check what the environment variable actually is
  console.log("REACT_APP_BASE_URL from env:", process.env.REACT_APP_BASE_URL);
  
  const defaultOptions = {
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
  };
  
  // Create instance
  let instance = axios.create(defaultOptions);

  instance.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
  );

  instance.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  );
  return instance;
};

// Step-2: Create request, response & error handlers
const requestHandler = (request: any) => {
  let storedToken: any = getToken();
  request.headers.Authorization = storedToken ? `Bearer ${storedToken?.token}` : "";
  
  // Debug: Log the full request details
  console.log("=== API Request Debug ===");
  console.log("Base URL:", request.baseURL);
  console.log("Request URL:", request.url);
  console.log("Full URL:", request.baseURL + request.url);
  console.log("Method:", request.method);
  console.log("=========================");
  
  return request;
};

const responseHandler = (response: any) => {
  return response;
};

// Public endpoints where 401 should not redirect to login (let component show error)
const publicEndpoints = ["users/signup", "users/confirm", "users/resend-code", "users/login"];

const errorHandler = (error: any) => {
  if (error?.response?.status === 401) {
    const requestUrl = error?.config?.url ?? "";
    const isPublicEndpoint = publicEndpoints.some((path) => requestUrl.includes(path));
    if (!isPublicEndpoint) {
      let userDataFromStorageLocal = localStorage.getItem("userData") || "{}";
      sessionStorage.setItem("tempRoute", JSON.stringify(window.location?.pathname));
      userDataFromStorageLocal !== "{}"
        ? localStorage.removeItem("userData")
        : sessionStorage.removeItem("userData");
      window.location.assign("/authentication/signin?tokenRevoked");
    }
  }
  return Promise.reject(error);
};

export default apiClient();
